import { useMediaQueryContext } from "lib/mediaQueryContext";
import NextImage from "next/image";
import Container from "components/shared/container/Container";

import {
    ImagesStyled,
    Grid,
    Top,
    Image,
    Bottom,
    Left,
    Right,
    Text
} from "./Images.styled";

export default function Images() {
    const { mobileView, desktopView } = useMediaQueryContext();

    return (
        <ImagesStyled>
            <Container>
                <Grid>
                    {mobileView && (
                        <>
                            <Top>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-1.jpg"
                                        alt=""
                                        layout="fill"
                                        objectFit="cover"
                                    />
                                </Image>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-7.jpg"
                                        alt=""
                                        layout="fill"
                                        objectFit="cover"
                                    />
                                </Image>
                            </Top>
                            <Bottom>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-8.jpg"
                                        alt=""
                                        layout="fill"
                                        objectFit="cover"
                                    />
                                </Image>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-5.jpg"
                                        alt=""
                                        layout="fill"
                                        objectFit="cover"
                                    />
                                </Image>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-6.jpg"
                                        alt=""
                                        layout="fill"
                                        objectFit="cover"
                                    />
                                </Image>
                            </Bottom>
                        </>
                    )}
                    {desktopView && (
                        <>
                            <Top>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-4.jpg"
                                        alt=""
                                        width={480}
                                        height={220}
                                    />
                                </Image>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-5.jpg"
                                        alt=""
                                        width={280}
                                        height={300}
                                    />
                                </Image>
                            </Top>
                            <Bottom>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-6.jpg"
                                        alt=""
                                        width={380}
                                        height={280}
                                    />
                                </Image>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-7.jpg"
                                        alt=""
                                        width={380}
                                        height={370}
                                    />
                                </Image>
                            </Bottom>
                            <Left>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-1.jpg"
                                        alt=""
                                        width={350}
                                        height={280}
                                    />
                                </Image>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-2.jpg"
                                        alt=""
                                        width={355}
                                        height={280}
                                    />
                                </Image>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-3.jpg"
                                        alt=""
                                        width={280}
                                        height={300}
                                    />
                                </Image>
                            </Left>
                            <Right>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-8.jpg"
                                        alt=""
                                        width={355}
                                        height={280}
                                    />
                                </Image>
                                <Image>
                                    <NextImage
                                        src="/images/about-photo-9.jpg"
                                        alt=""
                                        width={290}
                                        height={630}
                                    />
                                </Image>
                            </Right>
                        </>
                    )}
                    <Text>
                        Waar een aantal jaar geleden twee jonge ondernemers
                        begonnen staat nu een team van twintig. Allemaal met
                        verschillende achtergronden en interesses, maar met een
                        gedeeld enthousiasme en werkplezier!
                    </Text>
                </Grid>
            </Container>
        </ImagesStyled>
    );
}
